import { jsx } from "react/jsx-runtime";
import { Shape } from "./Shape.mjs";
const Button = () => /* @__PURE__ */ jsx(Shape, { height: "40px" });
export {
  Button
};
